














































import { Prop, Component, Vue } from "vue-property-decorator";
import { Company } from "@/api/company-api";
import companyType from "@/helpers/companyType";
import VSearchBar from "../components/VSearchBar.vue";

interface Item {
  id: string;
  type: string;
  name: string;
  tel: string;
  address: string;
}

@Component({
  components: {
    VSearchBar
  }
})
export default class CompanyList extends Vue {
  @Prop({ default: () => [] }) companies!: Company[];
  @Prop({ type: Boolean }) family!: boolean;

  get fields() {
    const fields = [
      {
        key: "name",
        label: "会社名",
        sortable: true
      },
      { key: "tel", label: "電話番号", sortable: true },
      { key: "address", label: "住所", sortable: true }
    ];
    if (this.family) {
      return fields;
    }
    return [
      {
        key: "favorite",
        label: ""
      }
    ].concat(fields);
  }

  filterOptions = [
    { text: "全て", value: "" },
    { text: "発注者", value: "client" },
    { text: "協力業者", value: "vendor" }
  ];

  get items() {
    return this.companies.map((c, index) => ({
      id: c.companyId,
      name: {
        index,
        name: c.name,
        type: companyType(c),
        company: { id: c.companyId }
      },
      tel: c.office.tel1,
      address: c.office.address,
      favorite: {
        id: c.companyId,
        favorite: c.favorite
      }
    }));
  }

  search(query: string) {
    this.$emit("search", query);
  }

  filter(role: string) {
    this.$emit("filter", role);
  }

  compare: (a: any, b: any) => number | null = () => null;

  changeSortType({ sortBy }: { sortBy: string }) {
    // nameはオブジェクトなので特別な比較関数を用意する
    if (sortBy === "name") {
      this.compare = this.compareName;
    } else {
      this.compare = () => null;
    }
  }

  updateFavorite(companyId: number, favorite: boolean) {
    this.$emit("updateFavorite", companyId, favorite);
  }

  private compareName(a: any, b: any) {
    if (a.name.name < b.name.name) return -1;
    if (a.name.name > b.name.name) return 1;
    return 0;
  }
}
